/**
 * CsvResponseデータ
 */
export default class CsvResponse {
    /** NDFP検査依頼ID */
    requestId = ""
    /** ステータス */
    status = ""
    /** 最終更新日時 */
    lastModifiedAt = ""
    /** キャンセル日 */
    cancelOn = ""
    /** キャンセル理由 */
    cancelReason = ""
    /** 検査所受付日 */
    requestConfirmationOn = ""
    /** 検査完了予定日 */
    deliveryOn = ""
    /** 報告書No */
    reportNo = ""
    /** 検査完了日(報告書提出日) */
    inspectionCompletionOn = ""
    /** 依頼受諾日 */
    requestRegistrationOn = ""
    /** 推奨日 */
    recommendedScheduledOn = ""
    /** 製造工場名 */
    companyFactoryName = ""
    /** 試料 */
    productName = ""
    /** カテゴリー */
    category = ""
    /** 可食重量 */
    edibleWeight = ""
    /** 内容量１ */
    internalCapacity1 = ""
    /** 内容量２ */
    internalCapacity2 = ""
    /** 内容量３ */
    internalCapacity3 = ""
    /** 内容量４ */
    internalCapacity4 = ""
    /** 内容量５ */
    internalCapacity5 = ""
    /** 内容量６ */
    internalCapacity6 = ""
    /** 内容量７ */
    internalCapacity7 = ""
    /** 内容量８ */
    internalCapacity8 = ""
    /** 内容量９ */
    internalCapacity9 = ""
    /** 内容量１０ */
    internalCapacity10 = ""
    /** 添付物１ */
    additive1 = ""
    /** 添付物２ */
    additive2 = ""
    /** 添付物３ */
    additive3 = ""
    /** 添付物４ */
    additive4 = ""
    /** 添付物５ */
    additive5 = ""
    /** 添付物６ */
    additive6 = ""
    /** 除外した部位 */
    excludedParts = ""
    /** 熱量(kcal/100g) */
    calorie100g = ""
    /** 熱量(単位：100g) */
    calorie100gUnit = ""
    /** 熱量(kcal/1食当り) */
    calorie1meal = ""
    /** 熱量(単位：1食当り) */
    calorie1mealUnit = ""
    /** 熱量(検査方法) */
    calorieInspectionMethod = ""
    /** たんぱく質(g/100g) */
    protein100g = ""
    /** たんぱく質(単位：100g) */
    protein100gUnit = ""
    /** たんぱく質(g/1食当り) */
    protein1meal = ""
    /** たんぱく質(単位：1食当り) */
    protein1mealUnit = ""
    /** たんぱく質(検査方法) */
    proteinInspectionMethod = ""
    /** 脂質(g/100g) */
    lipid100g = ""
    /** 脂質(単位：100g) */
    lipid100gUnit = ""
    /** 脂質(g/1食当り) */
    lipid1meal = ""
    /** 脂質(単位：1食当り) */
    lipid1mealUnit = ""
    /** 脂質(検査方法) */
    lipidInspectionMethod = ""
    /** 炭水化物(g/100g) */
    carbohydrate100g = ""
    /** 炭水化物(単位：100g) */
    carbohydrate100gUnit = ""
    /** 炭水化物(g/1食当り) */
    carbohydrate1meal = ""
    /** 炭水化物(単位：1食当り) */
    carbohydrate1mealUnit = ""
    /** 炭水化物(検査方法) */
    carbohydrateInspectionMethod = ""
    /** ナトリウム(mg/100g) */
    sodium100g = ""
    /** ナトリウム(単位：100g) */
    sodium100gUnit = ""
    /** ナトリウム(mg/1食当り) */
    sodium1meal = ""
    /** ナトリウム(単位：1食当り) */
    sodium1mealUnit = ""
    /** ナトリウム(検査方法) */
    sodiumInspectionMethod = ""
    /** 水分(g/100g) */
    moisture100g = ""
    /** 水分(単位：100g) */
    moisture100gUnit = ""
    /** 水分(g/1食当り) */
    moisture1meal = ""
    /** 水分(単位：1食当り) */
    moisture1mealUnit = ""
    /** 水分(検査方法) */
    moistureInspectionMethod = ""
    /** 灰分(g/100g) */
    ash100g = ""
    /** 灰分(単位：100g) */
    ash100gUnit = ""
    /** 灰分(g/1食当り) */
    ash1meal = ""
    /** 灰分(単位：1食当り) */
    ash1mealUnit = ""
    /** 灰分(検査方法) */
    ashInspectionMethod = ""
    /** オプション検査１(種類) */
    optionInspection1 = ""
    /** オプション検査１(/100g) */
    optionInspection100g1 = ""
    /** オプション検査１(単位：100g) */
    optionInspection100gUnit1 = ""
    /** オプション検査１(/1食当り) */
    optionInspection1meal1 = ""
    /** オプション検査１(単位：1食当り) */
    optionInspection1mealUnit1 = ""
    /** オプション検査１(検査方法) */
    optionInspectionMethod1 = ""
    /** オプション検査２(種類) */
    optionInspection2 = ""
    /** オプション検査２(/100g) */
    optionInspection100g2 = ""
    /** オプション検査２(単位：100g) */
    optionInspection100gUnit2 = ""
    /** オプション検査２(/1食当り) */
    optionInspection1meal2 = ""
    /** オプション検査２(単位：1食当り) */
    optionInspection1mealUnit2 = ""
    /** オプション検査２(検査方法) */
    optionInspectionMethod2 = ""
    /** オプション検査３(種類) */
    optionInspection3 = ""
    /** オプション検査３(/100g) */
    optionInspection100g3 = ""
    /** オプション検査３(単位：100g) */
    optionInspection100gUnit3 = ""
    /** オプション検査３(/1食当り) */
    optionInspection1meal3 = ""
    /** オプション検査３(単位：1食当り) */
    optionInspection1mealUnit3 = ""
    /** オプション検査３(検査方法) */
    optionInspectionMethod3 = ""
    /** オプション検査４(種類) */
    optionInspection4 = ""
    /** オプション検査４(/100g) */
    optionInspection100g4 = ""
    /** オプション検査４(単位：100g) */
    optionInspection100gUnit4 = ""
    /** オプション検査４(/1食当り) */
    optionInspection1meal4 = ""
    /** オプション検査４(単位：1食当り) */
    optionInspection1mealUnit4 = ""
    /** オプション検査４(検査方法) */
    optionInspectionMethod4 = ""
    /** 備考欄１ */
    note1 = ""
    /** 備考欄２ */
    note2 = ""
    /** 備考欄３ */
    note3 = ""
    /** 備考欄４ */
    note4 = ""
    /** 備考欄５ */
    note5 = ""
    /** 備考欄６ */
    note6 = ""
    /** 備考欄７ */
    note7 = ""
    /** 備考欄８ */
    note8 = ""
    /** 備考欄９ */
    note9 = ""
    /** 備考欄１０ */
    note10 = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<CsvResponse>) {
        Object.assign(this, init)
    }

    /**
     * CSV形式に変換
     */
    toCsv(separetor: string) {
        const result: string[] = []
        result.push(this.requestId)
        result.push(this.status)
        result.push(this.lastModifiedAt)
        result.push(this.cancelOn)
        result.push(this.cancelReason)
        result.push(this.requestConfirmationOn)
        result.push(this.deliveryOn)
        result.push(this.reportNo)
        result.push(this.inspectionCompletionOn)
        result.push(this.requestRegistrationOn)
        result.push(this.recommendedScheduledOn)
        result.push(this.companyFactoryName)
        result.push(this.productName)
        result.push(this.category)
        result.push(this.edibleWeight)
        result.push(this.internalCapacity1)
        result.push(this.internalCapacity2)
        result.push(this.internalCapacity3)
        result.push(this.internalCapacity4)
        result.push(this.internalCapacity5)
        result.push(this.internalCapacity6)
        result.push(this.internalCapacity7)
        result.push(this.internalCapacity8)
        result.push(this.internalCapacity9)
        result.push(this.internalCapacity10)
        result.push(this.additive1)
        result.push(this.additive2)
        result.push(this.additive3)
        result.push(this.additive4)
        result.push(this.additive5)
        result.push(this.additive6)
        result.push(this.excludedParts)
        result.push(this.calorie100g)
        result.push(this.calorie100gUnit)
        result.push(this.calorie1meal)
        result.push(this.calorie1mealUnit)
        result.push(this.calorieInspectionMethod)
        result.push(this.protein100g)
        result.push(this.protein100gUnit)
        result.push(this.protein1meal)
        result.push(this.protein1mealUnit)
        result.push(this.proteinInspectionMethod)
        result.push(this.lipid100g)
        result.push(this.lipid100gUnit)
        result.push(this.lipid1meal)
        result.push(this.lipid1mealUnit)
        result.push(this.lipidInspectionMethod)
        result.push(this.carbohydrate100g)
        result.push(this.carbohydrate100gUnit)
        result.push(this.carbohydrate1meal)
        result.push(this.carbohydrate1mealUnit)
        result.push(this.carbohydrateInspectionMethod)
        result.push(this.sodium100g)
        result.push(this.sodium100gUnit)
        result.push(this.sodium1meal)
        result.push(this.sodium1mealUnit)
        result.push(this.sodiumInspectionMethod)
        result.push(this.moisture100g)
        result.push(this.moisture100gUnit)
        result.push(this.moisture1meal)
        result.push(this.moisture1mealUnit)
        result.push(this.moistureInspectionMethod)
        result.push(this.ash100g)
        result.push(this.ash100gUnit)
        result.push(this.ash1meal)
        result.push(this.ash1mealUnit)
        result.push(this.ashInspectionMethod)
        result.push(this.optionInspection1)
        result.push(this.optionInspection100g1)
        result.push(this.optionInspection100gUnit1)
        result.push(this.optionInspection1meal1)
        result.push(this.optionInspection1mealUnit1)
        result.push(this.optionInspectionMethod1)
        result.push(this.optionInspection2)
        result.push(this.optionInspection100g2)
        result.push(this.optionInspection100gUnit2)
        result.push(this.optionInspection1meal2)
        result.push(this.optionInspection1mealUnit2)
        result.push(this.optionInspectionMethod2)
        result.push(this.optionInspection3)
        result.push(this.optionInspection100g3)
        result.push(this.optionInspection100gUnit3)
        result.push(this.optionInspection1meal3)
        result.push(this.optionInspection1mealUnit3)
        result.push(this.optionInspectionMethod3)
        result.push(this.optionInspection4)
        result.push(this.optionInspection100g4)
        result.push(this.optionInspection100gUnit4)
        result.push(this.optionInspection1meal4)
        result.push(this.optionInspection1mealUnit4)
        result.push(this.optionInspectionMethod4)
        result.push(this.note1)
        result.push(this.note2)
        result.push(this.note3)
        result.push(this.note4)
        result.push(this.note5)
        result.push(this.note6)
        result.push(this.note7)
        result.push(this.note8)
        result.push(this.note9)
        result.push(this.note10)

        return result.join(separetor)
    }

    /**
     * CSV形式に変換
     */
    validate(): string[] {
        const errors: string[] = []
        const datePattern = /^\d{8}$/g
        const edibleWeightPattern = /^([1-9]\d*|0)\.\d+(g|ml)$/g
        const weightPattern = /^([1-9]\d*|0)\.\d+g$/g
        const decimalPattern = /^([1-9]\d*|0)(\.\d+)?$/g

        /* NDFP検査依頼ID */
        if (this.requestId === "") errors.push("NDFP検査依頼IDは、必須項目です")
        if (this.requestId.length > 12) errors.push("NDFP検査依頼IDの文字数が長すぎます")
        /* ステータス */
        if (this.status === "") errors.push("ステータスは、必須項目です")
        if (this.status !== "" && !(this.status === "5" || this.status === "6" || this.status === "7" || this.status === "8")) errors.push("ステータスの値が不正です")
        /* 最終更新日時 */
        if (this.lastModifiedAt === "") errors.push("最終更新日時は、必須項目です")

        if (this.status === "5" || this.status === "6") {
            /* ステータス５：検査書受付済み、ステータス６：（検査所より）キャンセル */
            if (this.status === "5") {
                /* ステータス５：検査書受付済み */
                /* キャンセル日 */
                if (this.cancelOn !== "") errors.push("キャンセル日は未使用項目です")
                /* キャンセル理由 */
                if (this.cancelReason !== "") errors.push("キャンセル日は未使用項目です")
                /* 検査所受付日 */
                if (this.requestConfirmationOn === "") errors.push("検査所受付日は、必須項目です")
                if (this.requestConfirmationOn !== "" && !this.requestConfirmationOn.match(datePattern)) errors.push("検査所受付日の書式が不正です")
                /* 検査完了予定日 */
                if (this.deliveryOn === "") errors.push("検査完了予定日は、必須項目です")
                if (this.deliveryOn !== "" && !this.deliveryOn.match(datePattern)) errors.push("検査完了予定日の書式が不正です")
            } else {
                /* ステータス６：（検査所より）キャンセル */
                /* キャンセル日 */
                if (this.cancelOn === "") errors.push("キャンセル日は、必須項目です")
                if (this.cancelOn !== "" && !this.cancelOn.match(datePattern)) errors.push("キャンセル日の書式が不正です")
                /* キャンセル理由 */
                if (this.cancelReason === "") errors.push("キャンセル理由は、必須項目です")
                if (this.cancelReason !== "" && this.cancelReason.length > 100) errors.push("キャンセル理由の文字数が長すぎます")
                /* 検査所受付日 */
                if (this.requestConfirmationOn !== "") errors.push("検査所受付日は未使用項目です")
                /* 検査完了予定日 */
                if (this.deliveryOn !== "") errors.push("検査完了予定日は未使用項目です")
            }
            /* 報告書No */
            if (this.reportNo !== "") errors.push("報告書Noは未使用項目です")
            /* 検査完了日(報告書提出日) */
            if (this.inspectionCompletionOn !== "") errors.push("検査完了日(報告書提出日)は未使用項目です")
            /* 依頼受諾日 */
            if (this.requestRegistrationOn !== "") errors.push("依頼受諾日は未使用項目です")
            /* 推奨日 */
            if (this.recommendedScheduledOn !== "") errors.push("推奨日は未使用項目です")
            /* 製造工場名 */
            if (this.companyFactoryName !== "") errors.push("製造工場名は未使用項目です")
            /* 試料 */
            if (this.productName !== "") errors.push("試料は未使用項目です")
            /* カテゴリー */
            if (this.category !== "") errors.push("カテゴリーは未使用項目です")
            /* 可食重量 */
            if (this.edibleWeight !== "") errors.push("可食重量は未使用項目です")
            /* 内容量１ */
            if (this.internalCapacity1 !== "") errors.push("内容量１は未使用項目です")
            /* 内容量２ */
            if (this.internalCapacity2 !== "") errors.push("内容量２は未使用項目です")
            /* 内容量３ */
            if (this.internalCapacity3 !== "") errors.push("内容量３は未使用項目です")
            /* 内容量４ */
            if (this.internalCapacity4 !== "") errors.push("内容量４は未使用項目です")
            /* 内容量５ */
            if (this.internalCapacity5 !== "") errors.push("内容量５は未使用項目です")
            /* 内容量６ */
            if (this.internalCapacity6 !== "") errors.push("内容量６は未使用項目です")
            /* 内容量７ */
            if (this.internalCapacity7 !== "") errors.push("内容量７は未使用項目です")
            /* 内容量８ */
            if (this.internalCapacity8 !== "") errors.push("内容量８は未使用項目です")
            /* 内容量９ */
            if (this.internalCapacity9 !== "") errors.push("内容量９は未使用項目です")
            /* 内容量１０ */
            if (this.internalCapacity10 !== "") errors.push("内容量１０は未使用項目です")
            /* 添付物１ */
            if (this.additive1 !== "") errors.push("添付物１は未使用項目です")
            /* 添付物２ */
            if (this.additive2 !== "") errors.push("添付物２は未使用項目です")
            /* 添付物３ */
            if (this.additive3 !== "") errors.push("添付物３は未使用項目です")
            /* 添付物４ */
            if (this.additive4 !== "") errors.push("添付物４は未使用項目です")
            /* 添付物５ */
            if (this.additive5 !== "") errors.push("添付物５は未使用項目です")
            /* 添付物６ */
            if (this.additive6 !== "") errors.push("添付物６は未使用項目です")
            /* 除外した部位 */
            if (this.excludedParts !== "") errors.push("除外した部位は未使用項目です")
            /* 熱量(kcal/100g) */
            if (this.calorie100g !== "") errors.push("熱量(kcal/100g)は未使用項目です")
            /* 熱量(単位：100g) */
            if (this.calorie100gUnit !== "") errors.push("熱量(単位：100g)は未使用項目です")
            /* 熱量(kcal/1食当り) */
            if (this.calorie1meal !== "") errors.push("熱量(kcal/1食当り)は未使用項目です")
            /* 熱量(単位：1食当り) */
            if (this.calorie1mealUnit !== "") errors.push("熱量(単位：1食当り)は未使用項目です")
            /* 熱量(検査方法) */
            if (this.calorieInspectionMethod !== "") errors.push("熱量(検査方法)は未使用項目です")
            /* たんぱく質(g/100g) */
            if (this.protein100g !== "") errors.push("たんぱく質(g/100g)は未使用項目です")
            /* たんぱく質(単位：100g) */
            if (this.protein100gUnit !== "") errors.push("たんぱく質(単位：100g)は未使用項目です")
            /* たんぱく質(g/1食当り) */
            if (this.protein1meal !== "") errors.push("たんぱく質(g/1食当り)は未使用項目です")
            /* たんぱく質(単位：1食当り) */
            if (this.protein1mealUnit !== "") errors.push("たんぱく質(単位：1食当り)は未使用項目です")
            /* たんぱく質(検査方法) */
            if (this.proteinInspectionMethod !== "") errors.push("たんぱく質(検査方法)は未使用項目です")
            /* 脂質(g/100g) */
            if (this.lipid100g !== "") errors.push("脂質(g/100g)は未使用項目です")
            /* 脂質(単位：100g) */
            if (this.lipid100gUnit !== "") errors.push("脂質(単位：100g)は未使用項目です")
            /* 脂質(g/1食当り) */
            if (this.lipid1meal !== "") errors.push("脂質(g/1食当り)は未使用項目です")
            /* 脂質(単位：1食当り) */
            if (this.lipid1mealUnit !== "") errors.push("脂質(単位：1食当り)は未使用項目です")
            /* 脂質(検査方法) */
            if (this.lipidInspectionMethod !== "") errors.push("脂質(検査方法)は未使用項目です")
            /* 炭水化物(g/100g) */
            if (this.carbohydrate100g !== "") errors.push("炭水化物(g/100g)は未使用項目です")
            /* 炭水化物(単位：100g) */
            if (this.carbohydrate100gUnit !== "") errors.push("炭水化物(単位：100g)は未使用項目です")
            /* 炭水化物(g/1食当り) */
            if (this.carbohydrate1meal !== "") errors.push("炭水化物(g/1食当り)は未使用項目です")
            /* 炭水化物(単位：1食当り) */
            if (this.carbohydrate1mealUnit !== "") errors.push("炭水化物(単位：1食当り)は未使用項目です")
            /* 炭水化物(検査方法) */
            if (this.carbohydrateInspectionMethod !== "") errors.push("炭水化物(検査方法)は未使用項目です")
            /* ナトリウム(mg/100g) */
            if (this.sodium100g !== "") errors.push("ナトリウム(mg/100g)は未使用項目です")
            /* ナトリウム(単位：100g) */
            if (this.sodium100gUnit !== "") errors.push("ナトリウム(単位：100g)は未使用項目です")
            /* ナトリウム(mg/1食当り) */
            if (this.sodium1meal !== "") errors.push("ナトリウム(mg/1食当り)は未使用項目です")
            /* ナトリウム(単位：1食当り) */
            if (this.sodium1mealUnit !== "") errors.push("ナトリウム(単位：1食当り)は未使用項目です")
            /* ナトリウム(検査方法) */
            if (this.sodiumInspectionMethod !== "") errors.push("ナトリウム(検査方法)は未使用項目です")
            /* 水分(g/100g) */
            if (this.moisture100g !== "") errors.push("水分(g/100g)は未使用項目です")
            /* 水分(単位：100g) */
            if (this.moisture100gUnit !== "") errors.push("水分(単位：100g)は未使用項目です")
            /* 水分(g/1食当り) */
            if (this.moisture1meal !== "") errors.push("水分(g/1食当り)は未使用項目です")
            /* 水分(単位：1食当り) */
            if (this.moisture1mealUnit !== "") errors.push("水分(単位：1食当り)は未使用項目です")
            /* 水分(検査方法) */
            if (this.moistureInspectionMethod !== "") errors.push("水分(検査方法)は未使用項目です")
            /* 灰分(g/100g) */
            if (this.ash100g !== "") errors.push("灰分(g/100g)は未使用項目です")
            /* 灰分(単位：100g) */
            if (this.ash100gUnit !== "") errors.push("灰分(単位：100g)は未使用項目です")
            /* 灰分(g/1食当り) */
            if (this.ash1meal !== "") errors.push("灰分(g/1食当り)は未使用項目です")
            /* 灰分(単位：1食当り) */
            if (this.ash1mealUnit !== "") errors.push("灰分(単位：1食当り)は未使用項目です")
            /* 灰分(検査方法) */
            if (this.ashInspectionMethod !== "") errors.push("灰分(検査方法)は未使用項目です")
            /* オプション検査１(種類) */
            if (this.optionInspection1 !== "") errors.push("オプション検査１(種類)は未使用項目です")
            /* オプション検査１(/100g) */
            if (this.optionInspection100g1 !== "") errors.push("オプション検査１(/100g)は未使用項目です")
            /* オプション検査１(単位：100g) */
            if (this.optionInspection100gUnit1 !== "") errors.push("オプション検査１(単位：100g)は未使用項目です")
            /* オプション検査１(/1食当り) */
            if (this.optionInspection1meal1 !== "") errors.push("オプション検査１(/1食当り)は未使用項目です")
            /* オプション検査１(単位：1食当り) */
            if (this.optionInspection1mealUnit1 !== "") errors.push("オプション検査１(単位：1食当り)は未使用項目です")
            /* オプション検査１(検査方法) */
            if (this.optionInspectionMethod1 !== "") errors.push("オプション検査１(検査方法)は未使用項目です")
            /* オプション検査２(種類) */
            if (this.optionInspection2 !== "") errors.push("オプション検査２(種類)は未使用項目です")
            /* オプション検査２(/100g) */
            if (this.optionInspection100g2 !== "") errors.push("オプション検査２(/100g)は未使用項目です")
            /* オプション検査２(単位：100g) */
            if (this.optionInspection100gUnit2 !== "") errors.push("オプション検査２(単位：100g)は未使用項目です")
            /* オプション検査２(/1食当り) */
            if (this.optionInspection1meal2 !== "") errors.push("オプション検査２(/1食当り)は未使用項目です")
            /* オプション検査２(単位：1食当り) */
            if (this.optionInspection1mealUnit2 !== "") errors.push("オプション検査２(単位：1食当り)は未使用項目です")
            /* オプション検査２(検査方法) */
            if (this.optionInspectionMethod2 !== "") errors.push("オプション検査２(検査方法)は未使用項目です")
            /* オプション検査３(種類) */
            if (this.optionInspection3 !== "") errors.push("オプション検査３(種類)は未使用項目です")
            /* オプション検査３(/100g) */
            if (this.optionInspection100g3 !== "") errors.push("オプション検査３(/100g)は未使用項目です")
            /* オプション検査３(単位：100g) */
            if (this.optionInspection100gUnit3 !== "") errors.push("オプション検査３(単位：100g)は未使用項目です")
            /* オプション検査３(/1食当り) */
            if (this.optionInspection1meal3 !== "") errors.push("オプション検査３(/1食当り)は未使用項目です")
            /* オプション検査３(単位：1食当り) */
            if (this.optionInspection1mealUnit3 !== "") errors.push("オプション検査３(単位：1食当り)は未使用項目です")
            /* オプション検査３(検査方法) */
            if (this.optionInspectionMethod3 !== "") errors.push("オプション検査３(検査方法)は未使用項目です")
            /* オプション検査４(種類) */
            if (this.optionInspection4 !== "") errors.push("オプション検査４(種類)は未使用項目です")
            /* オプション検査４(/100g) */
            if (this.optionInspection100g4 !== "") errors.push("オプション検査４(/100g)は未使用項目です")
            /* オプション検査４(単位：100g) */
            if (this.optionInspection100gUnit4 !== "") errors.push("オプション検査４(単位：100g)は未使用項目です")
            /* オプション検査４(/1食当り) */
            if (this.optionInspection1meal4 !== "") errors.push("オプション検査４(/1食当り)は未使用項目です")
            /* オプション検査４(単位：1食当り) */
            if (this.optionInspection1mealUnit4 !== "") errors.push("オプション検査４(単位：1食当り)は未使用項目です")
            /* オプション検査４(検査方法) */
            if (this.optionInspectionMethod4 !== "") errors.push("オプション検査４(検査方法)は未使用項目です")
            /* 備考欄１ */
            if (this.note1 !== "") errors.push("備考欄１は未使用項目です")
            /* 備考欄２ */
            if (this.note2 !== "") errors.push("備考欄２は未使用項目です")
            /* 備考欄３ */
            if (this.note3 !== "") errors.push("備考欄３は未使用項目です")
            /* 備考欄４ */
            if (this.note4 !== "") errors.push("備考欄４は未使用項目です")
            /* 備考欄５ */
            if (this.note5 !== "") errors.push("備考欄５は未使用項目です")
            /* 備考欄６ */
            if (this.note6 !== "") errors.push("備考欄６は未使用項目です")
            /* 備考欄７ */
            if (this.note7 !== "") errors.push("備考欄７は未使用項目です")
            /* 備考欄８ */
            if (this.note8 !== "") errors.push("備考欄８は未使用項目です")
            /* 備考欄９ */
            if (this.note9 !== "") errors.push("備考欄９は未使用項目です")
            /* 備考欄１０ */
            if (this.note10 !== "") errors.push("備考欄１０は未使用項目です")
        } else if (this.status === "7" || this.status === "8") {
            /* ステータス７：検査結果報告(7種or7種＋オプション)、ステータス８：検査結果報告(オプション単独) */
            /* キャンセル日 */
            if (this.cancelOn !== "") errors.push("キャンセル日は未使用項目です")
            /* キャンセル理由 */
            if (this.cancelReason !== "") errors.push("キャンセル理由は未使用項目です")
            /* 検査所受付日 */
            if (this.requestConfirmationOn !== "" && !this.requestConfirmationOn.match(datePattern)) errors.push("検査所受付日の書式が不正です")
            /* 検査完了予定日 */
            if (this.deliveryOn !== "" && !this.deliveryOn.match(datePattern)) errors.push("検査完了予定日の書式が不正です")
            /* 報告書No */
            if (this.reportNo === "") errors.push("報告書Noは、必須項目です")
            if (this.reportNo !== "" && this.reportNo.length > 15) errors.push("報告書Noの文字数が長すぎます")
            /* 検査完了日(報告書提出日) */
            if (this.inspectionCompletionOn === "") errors.push("検査完了日(報告書提出日)は、必須項目です")
            if (this.inspectionCompletionOn !== "" && !this.inspectionCompletionOn.match(datePattern)) errors.push("検査完了日(報告書提出日)の書式が不正です")
            /* 依頼受諾日 */
            if (this.requestRegistrationOn !== "" && !this.requestRegistrationOn.match(datePattern)) errors.push("依頼受諾日の書式が不正です")
            /* 推奨日 */
            if (this.recommendedScheduledOn !== "" && !this.recommendedScheduledOn.match(datePattern)) errors.push("推奨日の書式が不正です")
            /* 製造工場名 */
            if (this.companyFactoryName.length > 60) errors.push("製造工場名の文字数が長すぎます")
            /* 試料 */
            if (this.productName.length > 100) errors.push("試料の文字数が長すぎます")
            /* カテゴリー */
            if (this.category.length > 20) errors.push("カテゴリーの文字数が長すぎます")
            /* 可食重量 */
            if (this.edibleWeight !== "" && !this.edibleWeight.match(edibleWeightPattern)) errors.push("可食重量の書式が不正です")
            /* 内容量１ */
            if ((this.status === "7" || this.status === "8") && this.internalCapacity1 === "") errors.push("内容量１は、必須項目です")
            if (this.internalCapacity1 !== "" && !this.internalCapacity1.match(weightPattern)) errors.push("内容量１の書式が不正です")
            /* 内容量２ */
            if (this.internalCapacity2 !== "" && !this.internalCapacity2.match(weightPattern)) errors.push("内容量２の書式が不正です")
            /* 内容量３ */
            if (this.internalCapacity3 !== "" && !this.internalCapacity3.match(weightPattern)) errors.push("内容量３の書式が不正です")
            /* 内容量４ */
            if (this.internalCapacity4 !== "" && !this.internalCapacity4.match(weightPattern)) errors.push("内容量４の書式が不正です")
            /* 内容量５ */
            if (this.internalCapacity5 !== "" && !this.internalCapacity5.match(weightPattern)) errors.push("内容量５の書式が不正です")
            /* 内容量６ */
            if (this.internalCapacity6 !== "" && !this.internalCapacity6.match(weightPattern)) errors.push("内容量６の書式が不正です")
            /* 内容量７ */
            if (this.internalCapacity7 !== "" && !this.internalCapacity7.match(weightPattern)) errors.push("内容量７の書式が不正です")
            /* 内容量８ */
            if (this.internalCapacity8 !== "" && !this.internalCapacity8.match(weightPattern)) errors.push("内容量８の書式が不正です")
            /* 内容量９ */
            if (this.internalCapacity9 !== "" && !this.internalCapacity9.match(weightPattern)) errors.push("内容量９の書式が不正です")
            /* 内容量１０ */
            if (this.internalCapacity10 !== "" && !this.internalCapacity10.match(weightPattern)) errors.push("内容量１０の書式が不正です")
            /* 添付物１ */
            if (this.additive1 !== "" && this.additive1.length > 40) errors.push("添付物１の文字数が長すぎます")
            /* 添付物２ */
            if (this.additive2 !== "" && this.additive2.length > 40) errors.push("添付物２の文字数が長すぎます")
            /* 添付物３ */
            if (this.additive3 !== "" && this.additive3.length > 40) errors.push("添付物３の文字数が長すぎます")
            /* 添付物４ */
            if (this.additive4 !== "" && this.additive4.length > 40) errors.push("添付物４の文字数が長すぎます")
            /* 添付物５ */
            if (this.additive5 !== "" && this.additive5.length > 40) errors.push("添付物５の文字数が長すぎます")
            /* 添付物６ */
            if (this.additive6 !== "" && this.additive6.length > 40) errors.push("添付物６の文字数が長すぎます")
            /* 除外した部位 */
            if (this.excludedParts !== "" && this.excludedParts.length > 80) errors.push("除外した部位の文字数が長すぎます")
            if (this.status === "7") {
                /* ステータス７：検査結果報告(7種or7種＋オプション) */
                /* 熱量(kcal/100g) */
                if (this.calorie100g === "") errors.push("熱量(kcal/100g)は、必須項目です")
                if (this.calorie100g !== "" && !this.calorie100g.match(decimalPattern)) errors.push("熱量(kcal/100g)の書式が不正です")
                /* 熱量(単位：100g) */
                if (this.calorie100gUnit === "") errors.push("熱量(単位：100g)は、必須項目です")
                if (this.calorie100gUnit !== "" && this.calorie100gUnit.length > 16) errors.push("熱量(単位：100g)の文字数が長すぎます")
                /* 熱量(kcal/1食当り) */
                if (this.calorie1meal === "") errors.push("熱量(kcal/1食当り)は、必須項目です")
                if (this.calorie1meal !== "" && !this.calorie1meal.match(decimalPattern)) errors.push("熱量(kcal/1食当り)の書式が不正です")
                /* 熱量(単位：1食当り) */
                if (this.calorie1mealUnit === "") errors.push("熱量(単位：1食当り)は、必須項目です")
                if (this.calorie1mealUnit !== "" && this.calorie1mealUnit.length > 16) errors.push("熱量(単位：1食当り)の文字数が長すぎます")
                /* 熱量(検査方法) */
                if (this.calorieInspectionMethod === "") errors.push("熱量(検査方法)は、必須項目です")
                if (this.calorieInspectionMethod !== "" && this.calorieInspectionMethod.length > 55) errors.push("熱量(検査方法)の文字数が長すぎます")
                /* たんぱく質(g/100g) */
                if (this.protein100g === "") errors.push("たんぱく質(g/100g)は、必須項目です")
                if (this.protein100g !== "" && !this.protein100g.match(decimalPattern)) errors.push("たんぱく質(g/100g)の書式が不正です")
                /* たんぱく質(単位：100g) */
                if (this.protein100gUnit === "") errors.push("たんぱく質(単位：100g)は、必須項目です")
                if (this.protein100gUnit !== "" && this.protein100gUnit.length > 16) errors.push("たんぱく質(単位：100g)の文字数が長すぎます")
                /* たんぱく質(g/1食当り) */
                if (this.protein1meal === "") errors.push("たんぱく質(g/1食当り)は、必須項目です")
                if (this.protein1meal !== "" && !this.protein1meal.match(decimalPattern)) errors.push("たんぱく質(g/1食当り)の書式が不正です")
                /* たんぱく質(単位：1食当り) */
                if (this.protein1mealUnit === "") errors.push("たんぱく質(単位：1食当り)は、必須項目です")
                if (this.protein1mealUnit !== "" && this.protein1mealUnit.length > 16) errors.push("たんぱく質(単位：1食当り)の文字数が長すぎます")
                /* たんぱく質(検査方法) */
                if (this.proteinInspectionMethod === "") errors.push("たんぱく質(検査方法)は、必須項目です")
                if (this.proteinInspectionMethod !== "" && this.proteinInspectionMethod.length > 55) errors.push("たんぱく質(検査方法)の文字数が長すぎます")
                /* 脂質(g/100g) */
                if (this.lipid100g === "") errors.push("脂質(g/100g)は、必須項目です")
                if (this.lipid100g !== "" && !this.lipid100g.match(decimalPattern)) errors.push("脂質(g/100g)の書式が不正です")
                /* 脂質(単位：100g) */
                if (this.lipid100gUnit === "") errors.push("脂質(単位：100g)は、必須項目です")
                if (this.lipid100gUnit !== "" && this.lipid100gUnit.length > 16) errors.push("脂質(単位：100g)の文字数が長すぎます")
                /* 脂質(g/1食当り) */
                if (this.lipid1meal === "") errors.push("脂質(g/1食当り)は、必須項目です")
                if (this.lipid1meal !== "" && !this.lipid1meal.match(decimalPattern)) errors.push("脂質(g/1食当り)の書式が不正です")
                /* 脂質(単位：1食当り) */
                if (this.lipid1mealUnit === "") errors.push("脂質(単位：1食当り)は、必須項目です")
                if (this.lipid1mealUnit !== "" && this.lipid1mealUnit.length > 16) errors.push("脂質(単位：1食当り)の文字数が長すぎます")
                /* 脂質(検査方法) */
                if (this.lipidInspectionMethod === "") errors.push("脂質(検査方法)は、必須項目です")
                if (this.lipidInspectionMethod !== "" && this.lipidInspectionMethod.length > 55) errors.push("脂質(検査方法)の文字数が長すぎます")
                /* 炭水化物(g/100g) */
                if (this.carbohydrate100g === "") errors.push("炭水化物(g/100g)は、必須項目です")
                if (this.carbohydrate100g !== "" && !this.carbohydrate100g.match(decimalPattern)) errors.push("炭水化物(g/100g)の書式が不正です")
                /* 炭水化物(単位：100g) */
                if (this.carbohydrate100gUnit === "") errors.push("炭水化物(単位：100g)は、必須項目です")
                if (this.carbohydrate100gUnit !== "" && this.carbohydrate100gUnit.length > 16) errors.push("炭水化物(単位：100g)の文字数が長すぎます")
                /* 炭水化物(g/1食当り) */
                if (this.carbohydrate1meal === "") errors.push("炭水化物(g/1食当り)は、必須項目です")
                if (this.carbohydrate1meal !== "" && !this.carbohydrate1meal.match(decimalPattern)) errors.push("炭水化物(g/1食当り)の書式が不正です")
                /* 炭水化物(単位：1食当り) */
                if (this.carbohydrate1mealUnit === "") errors.push("炭水化物(単位：1食当り)は、必須項目です")
                if (this.carbohydrate1mealUnit !== "" && this.carbohydrate1mealUnit.length > 16) errors.push("炭水化物(単位：1食当り)の文字数が長すぎます")
                /* 炭水化物(検査方法) */
                if (this.carbohydrateInspectionMethod === "") errors.push("炭水化物(検査方法)は、必須項目です")
                if (this.carbohydrateInspectionMethod !== "" && this.carbohydrateInspectionMethod.length > 55) errors.push("炭水化物(検査方法)の文字数が長すぎます")
                /* ナトリウム(mg/100g) */
                if (this.sodium100g === "") errors.push("ナトリウム(mg/100g)は、必須項目です")
                if (this.sodium100g !== "" && !this.sodium100g.match(decimalPattern)) errors.push("ナトリウム(mg/100g)の書式が不正です")
                /* ナトリウム(単位：100g) */
                if (this.sodium100gUnit === "") errors.push("ナトリウム(単位：100g)は、必須項目です")
                if (this.sodium100gUnit !== "" && this.sodium100gUnit.length > 16) errors.push("ナトリウム(単位：100g)の文字数が長すぎます")
                /* ナトリウム(mg/1食当り) */
                if (this.sodium1meal === "") errors.push("ナトリウム(mg/1食当り)は、必須項目です")
                if (this.sodium1meal !== "" && !this.sodium1meal.match(decimalPattern)) errors.push("ナトリウム(mg/1食当り)の書式が不正です")
                /* ナトリウム(単位：1食当り) */
                if (this.sodium1mealUnit === "") errors.push("ナトリウム(単位：1食当り)は、必須項目です")
                if (this.sodium1mealUnit !== "" && this.sodium1mealUnit.length > 16) errors.push("ナトリウム(単位：1食当りの文字数が長すぎます")
                /* ナトリウム(検査方法) */
                if (this.sodiumInspectionMethod === "") errors.push("ナトリウム(検査方法)は、必須項目です")
                if (this.sodiumInspectionMethod !== "" && this.sodiumInspectionMethod.length > 55) errors.push("ナトリウム(検査方法)の文字数が長すぎます")
                /* 水分(g/100g) */
                if (this.moisture100g === "") errors.push("水分(g/100g)は、必須項目です")
                if (this.moisture100g !== "" && !this.moisture100g.match(decimalPattern)) errors.push("水分(g/100g)の書式が不正です")
                /* 水分(単位：100g) */
                if (this.moisture100gUnit === "") errors.push("水分(単位：100g)は、必須項目です")
                if (this.moisture100gUnit !== "" && this.moisture100gUnit.length > 16) errors.push("水分(単位：100g)の文字数が長すぎます")
                /* 水分(g/1食当り) */
                if (this.moisture1meal === "") errors.push("水分(g/1食当り)は、必須項目です")
                if (this.moisture1meal !== "" && !this.moisture1meal.match(decimalPattern)) errors.push("水分(g/1食当り)の書式が不正です")
                /* 水分(単位：1食当り) */
                if (this.moisture1mealUnit === "") errors.push("水分(単位：1食当り)は、必須項目です")
                if (this.moisture1mealUnit !== "" && this.moisture1mealUnit.length > 16) errors.push("水分(単位：1食当り)の文字数が長すぎます")
                /* 水分(検査方法) */
                if (this.moistureInspectionMethod === "") errors.push("水分(検査方法)は、必須項目です")
                if (this.moistureInspectionMethod !== "" && this.moistureInspectionMethod.length > 55) errors.push("水分(検査方法)の文字数が長すぎます")
                /* 灰分(g/100g) */
                if (this.ash100g === "") errors.push("灰分(g/100g)は、必須項目です")
                if (this.ash100g !== "" && !this.ash100g.match(decimalPattern)) errors.push("灰分(g/100g)の書式が不正です")
                /* 灰分(単位：100g) */
                if (this.ash100gUnit === "") errors.push("灰分(単位：100g)は、必須項目です")
                if (this.ash100gUnit !== "" && this.ash100gUnit.length > 16) errors.push("灰分(単位：100g)の文字数が長すぎます")
                /* 灰分(g/1食当り) */
                if (this.ash1meal === "") errors.push("灰分(g/1食当り)は、必須項目です")
                if (this.ash1meal !== "" && !this.ash1meal.match(decimalPattern)) errors.push("灰分(g/1食当り)の書式が不正です")
                /* 灰分(単位：1食当り) */
                if (this.ash1mealUnit === "") errors.push("灰分(単位：1食当り)は、必須項目です")
                if (this.ash1mealUnit !== "" && this.ash1mealUnit.length > 16) errors.push("灰分(単位：1食当り)の文字数が長すぎます")
                /* 灰分(検査方法) */
                if (this.ashInspectionMethod === "") errors.push("灰分(検査方法)は、必須項目です")
                if (this.ashInspectionMethod !== "" && this.ashInspectionMethod.length > 55) errors.push("灰分(検査方法)の文字数が長すぎます")
                /* オプション検査１(種類) */
                if (this.optionInspection1 !== "" && this.optionInspection1.length > 40) errors.push("オプション検査１(種類)の文字数が長すぎます")
                /* オプション検査１(/100g) */
                if (this.optionInspection100g1 !== "" && !this.optionInspection100g1.match(decimalPattern)) errors.push("オプション検査１(/100g)の書式が不正です")
                /* オプション検査１(単位：100g) */
                if (this.optionInspection100gUnit1 !== "" && this.optionInspection100gUnit1.length > 16) errors.push("オプション検査１(単位：100g)の文字数が長すぎます")
                /* オプション検査１(/1食当り) */
                if (this.optionInspection1meal1 !== "" && !this.optionInspection1meal1.match(decimalPattern)) errors.push("オプション検査１(/1食当り)の書式が不正です")
                /* オプション検査１(単位：1食当り) */
                if (this.optionInspection1mealUnit1 !== "" && this.optionInspection1mealUnit1.length > 16) errors.push("オプション検査１(単位：1食当り)の文字数が長すぎます")
                /* オプション検査１(検査方法) */
                if (this.optionInspectionMethod1 !== "" && this.optionInspectionMethod1.length > 55) errors.push("オプション検査１(検査方法)の文字数が長すぎます")
            } else {
                /* ステータス８：検査結果報告(オプション単独) */
                /* 熱量(kcal/100g) */
                if (this.calorie100g !== "") errors.push("熱量(kcal/100g)は未使用項目です")
                /* 熱量(単位：100g) */
                if (this.calorie100gUnit !== "") errors.push("熱量(単位：100g)は未使用項目です")
                /* 熱量(kcal/1食当り) */
                if (this.calorie1meal !== "") errors.push("熱量(kcal/1食当り)は未使用項目です")
                /* 熱量(単位：1食当り) */
                if (this.calorie1mealUnit !== "") errors.push("熱量(単位：1食当り)は未使用項目です")
                /* 熱量(検査方法) */
                if (this.calorieInspectionMethod !== "") errors.push("熱量(検査方法)は未使用項目です")
                /* たんぱく質(g/100g) */
                if (this.protein100g !== "") errors.push("たんぱく質(g/100g)は未使用項目です")
                /* たんぱく質(単位：100g) */
                if (this.protein100gUnit !== "") errors.push("たんぱく質(単位：100g)は未使用項目です")
                /* たんぱく質(g/1食当り) */
                if (this.protein1meal !== "") errors.push("たんぱく質(g/1食当り)は未使用項目です")
                /* たんぱく質(単位：1食当り) */
                if (this.protein1mealUnit !== "") errors.push("たんぱく質(単位：1食当り)は未使用項目です")
                /* たんぱく質(検査方法) */
                if (this.proteinInspectionMethod !== "") errors.push("たんぱく質(検査方法)は未使用項目です")
                /* 脂質(g/100g) */
                if (this.lipid100g !== "") errors.push("脂質(g/100g)は未使用項目です")
                /* 脂質(単位：100g) */
                if (this.lipid100gUnit !== "") errors.push("脂質(単位：100g)は未使用項目です")
                /* 脂質(g/1食当り) */
                if (this.lipid1meal !== "") errors.push("脂質(g/1食当り)は未使用項目です")
                /* 脂質(単位：1食当り) */
                if (this.lipid1mealUnit !== "") errors.push("脂質(単位：1食当り)は未使用項目です")
                /* 脂質(検査方法) */
                if (this.lipidInspectionMethod !== "") errors.push("脂質(検査方法)は未使用項目です")
                /* 炭水化物(g/100g) */
                if (this.carbohydrate100g !== "") errors.push("炭水化物(g/100g)は未使用項目です")
                /* 炭水化物(単位：100g) */
                if (this.carbohydrate100gUnit !== "") errors.push("炭水化物(単位：100g)は未使用項目です")
                /* 炭水化物(g/1食当り) */
                if (this.carbohydrate1meal !== "") errors.push("炭水化物(g/1食当り)は未使用項目です")
                /* 炭水化物(単位：1食当り) */
                if (this.carbohydrate1mealUnit !== "") errors.push("炭水化物(単位：1食当り)は未使用項目です")
                /* 炭水化物(検査方法) */
                if (this.carbohydrateInspectionMethod !== "") errors.push("炭水化物(検査方法)は未使用項目です")
                /* ナトリウム(mg/100g) */
                if (this.sodium100g !== "") errors.push("ナトリウム(mg/100g)は未使用項目です")
                /* ナトリウム(単位：100g) */
                if (this.sodium100gUnit !== "") errors.push("ナトリウム(単位：100g)は未使用項目です")
                /* ナトリウム(mg/1食当り) */
                if (this.sodium1meal !== "") errors.push("ナトリウム(mg/1食当り)は未使用項目です")
                /* ナトリウム(単位：1食当り) */
                if (this.sodium1mealUnit !== "") errors.push("ナトリウム(単位：1食当り)は未使用項目です")
                /* ナトリウム(検査方法) */
                if (this.sodiumInspectionMethod !== "") errors.push("ナトリウム(検査方法)は未使用項目です")
                /* 水分(g/100g) */
                if (this.moisture100g !== "") errors.push("水分(g/100g)は未使用項目です")
                /* 水分(単位：100g) */
                if (this.moisture100gUnit !== "") errors.push("水分(単位：100g)は未使用項目です")
                /* 水分(g/1食当り) */
                if (this.moisture1meal !== "") errors.push("水分(g/1食当り)は未使用項目です")
                /* 水分(単位：1食当り) */
                if (this.moisture1mealUnit !== "") errors.push("水分(単位：1食当り)は未使用項目です")
                /* 水分(検査方法) */
                if (this.moistureInspectionMethod !== "") errors.push("水分(検査方法)は未使用項目です")
                /* 灰分(g/100g) */
                if (this.ash100g !== "") errors.push("灰分(g/100g)は未使用項目です")
                /* 灰分(単位：100g) */
                if (this.ash100gUnit !== "") errors.push("灰分(単位：100g)は未使用項目です")
                /* 灰分(g/1食当り) */
                if (this.ash1meal !== "") errors.push("灰分(g/1食当り)は未使用項目です")
                /* 灰分(単位：1食当り) */
                if (this.ash1mealUnit !== "") errors.push("灰分(単位：1食当り)は未使用項目です")
                /* 灰分(検査方法) */
                if (this.ashInspectionMethod !== "") errors.push("灰分(検査方法)は未使用項目です")
                /* オプション検査１(種類) */
                if (this.optionInspection1 === "") errors.push("オプション検査１(種類)は、必須項目です")
                if (this.optionInspection1 !== "" && this.optionInspection1.length > 40) errors.push("オプション検査１(種類)の文字数が長すぎます")
                /* オプション検査１(/100g) */
                if (this.optionInspection100g1 === "") errors.push("オプション検査１(/100g)は、必須項目です")
                if (this.optionInspection100g1 !== "" && !this.optionInspection100g1.match(decimalPattern)) errors.push("オプション検査１(/100g)の書式が不正です")
                /* オプション検査１(単位：100g) */
                if (this.optionInspection100gUnit1 === "") errors.push("オプション検査１(単位：100g)は、必須項目です")
                if (this.optionInspection100gUnit1 !== "" && this.optionInspection100gUnit1.length > 16) errors.push("オプション検査１(単位：100g)の文字数が長すぎます")
                /* オプション検査１(/1食当り) */
                if (this.optionInspection1meal1 === "") errors.push("オプション検査１(/1食当り)は、必須項目です")
                if (this.optionInspection1meal1 !== "" && !this.optionInspection1meal1.match(decimalPattern)) errors.push("オプション検査１(/1食当り)の書式が不正です")
                /* オプション検査１(単位：1食当り) */
                if (this.optionInspection1mealUnit1 === "") errors.push("オプション検査１(単位：1食当り)は、必須項目です")
                if (this.optionInspection1mealUnit1 !== "" && this.optionInspection1mealUnit1.length > 16) errors.push("オプション検査１(単位：1食当り)の文字数が長すぎます")
                /* オプション検査１(検査方法) */
                if (this.optionInspectionMethod1 === "") errors.push("オプション検査１(検査方法)は、必須項目です")
                if (this.optionInspectionMethod1 !== "" && this.optionInspectionMethod1.length > 55) errors.push("オプション検査１(検査方法)の文字数が長すぎます")
            }
            /* オプション検査２(種類) */
            if (this.optionInspection2 !== "" && this.optionInspection2.length > 40) errors.push("オプション検査２(種類)の文字数が長すぎます")
             /* オプション検査２(/100g) */
            if (this.optionInspection100g2 !== "" && !this.optionInspection100g2.match(decimalPattern)) errors.push("オプション検査２(/100g)の書式が不正です")
            /* オプション検査２(単位：100g) */
            if (this.optionInspection100gUnit2 !== "" && this.optionInspection100gUnit2.length > 16) errors.push("オプション検査２(単位：100g)の文字数が長すぎます")
            /* オプション検査２(/1食当り) */
            if (this.optionInspection1meal2 !== "" && !this.optionInspection1meal2.match(decimalPattern)) errors.push("オプション検査２(/1食当り)の書式が不正です")
            /* オプション検査２(単位：1食当り) */
            if (this.optionInspection1mealUnit2 !== "" && this.optionInspection1mealUnit2.length > 16) errors.push("オプション検査２(単位：1食当り)の文字数が長すぎます")
            /* オプション検査２(検査方法) */
            if (this.optionInspectionMethod2 !== "" && this.optionInspectionMethod2.length > 55) errors.push("オプション検査２(検査方法)の文字数が長すぎます")
            /* オプション検査３(種類) */
            if (this.optionInspection3 !== "" && this.optionInspection3.length > 40) errors.push("オプション検査３(種類)の文字数が長すぎます")
            /* オプション検査３(/100g) */
            if (this.optionInspection100g3 !== "" && !this.optionInspection100g3.match(decimalPattern)) errors.push("オプション検査３(/100g)の書式が不正です")
            /* オプション検査３(単位：100g) */
            if (this.optionInspection100gUnit3 !== "" && this.optionInspection100gUnit3.length > 16) errors.push("オプション検査３(単位：100g)の文字数が長すぎます")
            /* オプション検査３(/1食当り) */
            if (this.optionInspection1meal3 !== "" && !this.optionInspection1meal3.match(decimalPattern)) errors.push("オプション検査３(/1食当り)の書式が不正です")
            /* オプション検査３(単位：1食当り) */
            if (this.optionInspection1mealUnit3 !== "" && this.optionInspection1mealUnit3.length > 16) errors.push("オプション検査３(単位：1食当り)の文字数が長すぎます")
            /* オプション検査３(検査方法) */
            if (this.optionInspectionMethod3 !== "" && this.optionInspectionMethod3.length > 55) errors.push("オプション検査３(検査方法)の文字数が長すぎます")
            /* オプション検査４(種類) */
            if (this.optionInspection4 !== "" && this.optionInspection4.length > 40) errors.push("オプション検査４(種類)の文字数が長すぎます")
            /* オプション検査４(/100g) */
            if (this.optionInspection100g4 !== "" && !this.optionInspection100g4.match(decimalPattern)) errors.push("オプション検査４(/100g)の書式が不正です")
            /* オプション検査４(単位：100g) */
            if (this.optionInspection100gUnit4 !== "" && this.optionInspection100gUnit4.length > 16) errors.push("オプション検査４(単位：100g)の文字数が長すぎます")
            /* オプション検査４(/1食当り) */
            if (this.optionInspection1meal4 !== "" && !this.optionInspection1meal4.match(decimalPattern)) errors.push("オプション検査４(/1食当り)の書式が不正です")
            /* オプション検査４(単位：1食当り) */
            if (this.optionInspection1mealUnit4 !== "" && this.optionInspection1mealUnit4.length > 16) errors.push("オプション検査４(単位：1食当り)の文字数が長すぎます")
            /* オプション検査４(検査方法) */
            if (this.optionInspectionMethod4 !== "" && this.optionInspectionMethod4.length > 55) errors.push("オプション検査４(検査方法)の文字数が長すぎます")
            /* 備考欄１ */
            if (this.note1.length > 2000) errors.push("備考欄１の文字数が長すぎます")
            /* 備考欄２ */
            if (this.note2.length > 250) errors.push("備考欄２の文字数が長すぎます")
            /* 備考欄３ */
            if (this.note3.length > 250) errors.push("備考欄３の文字数が長すぎます")
            /* 備考欄４ */
            if (this.note4.length > 250) errors.push("備考欄４の文字数が長すぎます")
            /* 備考欄５ */
            if (this.note5.length > 250) errors.push("備考欄５の文字数が長すぎます")
            /* 備考欄６ */
            if (this.note6.length > 250) errors.push("備考欄６の文字数が長すぎます")
            /* 備考欄７ */
            if (this.note7.length > 250) errors.push("備考欄７の文字数が長すぎます")
            /* 備考欄８ */
            if (this.note8.length > 250) errors.push("備考欄８の文字数が長すぎます")
            /* 備考欄９ */
            if (this.note9.length > 250) errors.push("備考欄９の文字数が長すぎます")
            /* 備考欄１０ */
            if (this.note10.length > 250) errors.push("備考欄１０の文字数が長すぎます")
        }
        return errors
    }

    /**
     * ヘッダーを取得する
     */
    static getHeader() {
        return ["NDFP検査依頼ID",
            "ステータス",
            "最終更新日時",
            "キャンセル日",
            "キャンセル理由",
            "検査所受付日",
            "検査完了予定日",
            "報告書No",
            "検査完了日（報告書提出日）",
            "依頼受託日",
            "推奨日",
            "製造工場名",
            "試料",
            "カテゴリー",
            "可食重量",
            "内容量１",
            "内容量２",
            "内容量３",
            "内容量４",
            "内容量５",
            "内容量６",
            "内容量７",
            "内容量８",
            "内容量９",
            "内容量１０",
            "添付物１",
            "添付物２",
            "添付物３",
            "添付物４",
            "添付物５",
            "添付物６",
            "除外した部位",
            "熱量（kcal/100g）",
            "熱量（単位：100g）",
            "熱量（kcal/1食当たり）",
            "熱量（単位:1食当たり）",
            "熱量（検査方法）",
            "たんぱく質（g/100g）",
            "たんぱく質（単位:100g）",
            "たんぱく質（g/1食当たり）",
            "たんぱく質（単位:1食当たり）",
            "たんぱく質（検査方法）",
            "脂質（g/100g）",
            "脂質（単位:100g）",
            "脂質（g/1食当たり）",
            "脂質（単位:1食当たり）",
            "脂質（検査方法）",
            "炭水化物（g/100g）",
            "炭水化物（単位:100g）",
            "炭水化物（g/1食当たり）",
            "炭水化物（単位:1食当たり）",
            "炭水化物（検査方法）",
            "ナトリウム（mg/100g）",
            "ナトリウム（単位:100g）",
            "ナトリウム（mg/1食当たり）",
            "ナトリウム（単位:1食当たり）",
            "ナトリウム（検査方法）",
            "水分（g/100g）",
            "水分（単位:100g）",
            "水分（g/1食当たり）",
            "水分（単位:1食当たり）",
            "水分（検査方法）",
            "灰分（g/100g）",
            "灰分（単位:100g）",
            "灰分（g/1食当たり）",
            "灰分（単位:1食当たり）",
            "灰分（検査方法）",
            "オプション検査１（種類）",
            "オプション検査１（/100g）",
            "オプション検査１（単位：100g）",
            "オプション検査１（/1食当たり）",
            "オプション検査１（単位:1食当たり）",
            "オプション検査１（検査方法）",
            "オプション検査２（種類）",
            "オプション検査２（/100g）",
            "オプション検査２（単位：100g）",
            "オプション検査２（/1食当たり）",
            "オプション検査２（単位:1食当たり）",
            "オプション検査２（検査方法）",
            "オプション検査３（種類）",
            "オプション検査３（/100g）",
            "オプション検査３（単位：100g）",
            "オプション検査３（/1食当たり）",
            "オプション検査３（単位:1食当たり）",
            "オプション検査３（検査方法）",
            "オプション検査４（種類）",
            "オプション検査４（/100g）",
            "オプション検査４単位：100g）",
            "オプション検査４（/1食当たり）",
            "オプション検査４（単位:1食当たり）",
            "オプション検査４（検査方法）",
            "備考欄１",
            "備考欄２",
            "備考欄３",
            "備考欄４",
            "備考欄５",
            "備考欄６",
            "備考欄７",
            "備考欄８",
            "備考欄９",
            "備考欄１０",
        ]
    }
   
}
